/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.SmsAuth = class SmsAuth {
  constructor(el) {
    this._enableSubmit = this._enableSubmit.bind(this);
    this._disableSubmit = this._disableSubmit.bind(this);
    this._updateSubmitButton = this._updateSubmitButton.bind(this);
    this._submit = this._submit.bind(this);
    this._smsAuthSuccess = this._smsAuthSuccess.bind(this);
    this._smsAuthError = this._smsAuthError.bind(this);
    this.el = el;
    this.form = this.el.find("[data-auth-form]").find("form");

    this.input = this.el.find("[data-token-input]").find("input");
    this.input.on("input", this._updateSubmitButton);
    this.inputPattern = this.input.data("pattern");

    this.submitButton = this.el.find("[data-submit-button]");
    this.submitButton.on("click", this._submit);
  }

  _enableSubmit() {
    return this.submitButton.removeAttr("disabled");
  }

  _disableSubmit() {
    return this.submitButton.attr('disabled','disabled');
  }

  _updateSubmitButton() {
    if (new Buyapowa.Helpers.CustomPatternValidator(this.input).isValid()) {
      return this._enableSubmit();
    } else {
      return this._disableSubmit();
    }
  }

  _submit(e) {
    e.preventDefault();

    return $.ajax({
      type: "POST",
      url: this.form.attr("action"),
      data: this.form.serializeObject(),
      dataType: 'json',
      success: data => {
        if (data.success) {
          return this._smsAuthSuccess(data.url);
        } else {
          return this._smsAuthError(data.url);
        }
      }
    });
  }

  _smsAuthSuccess(url) {
    return window.open(url, "_parent");
  }

  _smsAuthError(url) {
    if (url) {
      return window.open(url, "_parent");
    } else {
      return this.el.find("[data-form-error]").removeClass('hide');
    }
  }
};
